import * as React from "react";

import ButtonMui from "@mui/material/Button";

import {
  Link,
  Reference
} from "../../models/app-data-model";
import { getContentHubDamAsset } from "../../../shared/utils/get-contenthub-dam-asset";

export type ButtonProps = {
  className: string;
  label: string;
  reference?: Reference[];
  link?: Link[]
};

export type buttonVariant = 'text' | 'contained' | 'outlined';

const Button: React.FC<ButtonProps> = ({ className, label, reference, link}: ButtonProps) => {
  const buttonVariant = className?.toLowerCase() as buttonVariant;
  const url = (reference && reference[0]?.url) || (reference && getContentHubDamAsset(reference[0]?.contenthub_asset)?.url) || (link && link[0]?.href);  
  return <ButtonMui variant={buttonVariant} href={url} size='medium'>{label}</ButtonMui>
};

export default Button;
